import type { AppData } from 'types/documentServices';
import type { Shell } from '#packages/apilib';
import { EditorAPIKey } from '#packages/apis';
import type { UninstallAppOptions } from '../services/uninstallService';
import { uninstallApp } from '../services/uninstallService';
import { EditorPlatformHostIntegrationAPI } from '@wix/editor-platform-host-integration-apis';
import packagesConstants from '#packages/constants';
import * as stateManagement from '#packages/stateManagement';

export default (shell: Shell) => {
  const editorAPI = shell.getAPI(EditorAPIKey);

  const uninstall = (
    appData: AppData,
    shouldShowModal = true,
    options: UninstallAppOptions = {},
  ) => {
    return uninstallApp(editorAPI, appData, shouldShowModal, options);
  };

  const isSilentInstallRunning = (): boolean => {
    const editorPlatformHostIntegrationAPI = editorAPI.host.getAPI(
      EditorPlatformHostIntegrationAPI,
    );

    return editorPlatformHostIntegrationAPI.applications.isSilentInstallRunning();
  };

  const isIntentInstallRunning = (): boolean => {
    const editorPlatformHostIntegrationAPI = editorAPI.host.getAPI(
      EditorPlatformHostIntegrationAPI,
    );

    return (
      editorPlatformHostIntegrationAPI.applications.isIntentInstallRunning?.() ??
      false
    );
  };

  const checkApplicationsVersions = async () => {
    try {
      const apps = editorAPI.dsRead.platform
        .getInstalledEditorApps()
        .filter((app) => app.type === 'editor');

      const platformAPI = editorAPI.host.getAPI(
        EditorPlatformHostIntegrationAPI,
      );

      let updates = 0;

      const latestVersions = editorAPI.store.getState().platform.latestVersions;

      apps.forEach((app) => {
        if (
          platformAPI.applications.isAppUpdateAvailable(
            app.appDefinitionId,
            latestVersions[app.appDefinitionId],
          )
        ) {
          updates++;
        }
      });

      editorAPI.store.dispatch(
        stateManagement.leftBar.actions.setNotificationsCount(
          packagesConstants.ROOT_COMPS.LEFTBAR.APP_MANAGER_PANEL_NAME,
          updates,
        ),
      );
    } catch (e) {
      console.error('Failed to check applications versions', e);
    }
  };

  return {
    checkApplicationsVersions,
    isSilentInstallRunning,
    isIntentInstallRunning,
    uninstall,
  };
};
